import React from 'react';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  hint?: string;
}

const FormField: React.FC<FormFieldProps> = ({ label, children, hint }) => {
  return (
    <label className="block">
      <div className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1">{label}</div>
      {children}
      {hint ? <div className="text-xs text-slate-500 mt-1">{hint}</div> : null}
    </label>
  );
};

export default FormField;

